const r = {
  colors: {
    neutral: {
      0: "#ffffff",
      50: "#FAFAFA",
      100: "#F5F5F5",
      200: "#F0F0F0",
      300: "#E6E6E6",
      400: "#D4D4D4",
      500: "#9C9C9C",
      600: "#757575",
      700: "#4D4D4D",
      800: "#0D0D0D",
      900: "#000000"
    },
    transparent: {
      50: "rgba(0, 0, 0, 0.02)",
      100: "rgba(0, 0, 0, 0.04)",
      200: "rgba(0, 0, 0, 0.06)",
      300: "rgba(0, 0, 0, 0.1)",
      400: "rgba(0, 0, 0, 0.18)",
      500: "rgba(0, 0, 0, 0.39)"
    },
    brand: {
      50: "#F6FAFF",
      100: "#E4E4F9",
      200: "#C6C6F3",
      300: "#A1A3ED",
      400: "#334EFF",
      500: "#001EE1",
      600: "#001BC9",
      700: "#0017AE",
      800: "#00138E",
      900: "#000D65"
    },
    gradient: {
      brand: "linear-gradient(90deg, #1862FF 0%, #7508AF 100%)",
      neutral: "linear-gradient(90deg, #868686 0%, #161616 20.02%, #868686 55.46%, #2A2A2A 90.19%)"
    },
    status: {
      success: {
        main: "#11C872",
        50: "#F1FAE5",
        100: "#EEF9E1",
        200: "#E5F6D4",
        300: "#D3F1C0",
        400: "#B6E8A3",
        500: "#87DD80",
        600: "#58CD68",
        700: "#3AA862",
        800: "#2C7051",
        900: "#19352D"
      },
      warning: {
        main: "#FFC107",
        50: "",
        100: "",
        200: "",
        300: "",
        400: "",
        500: "",
        600: "",
        700: "",
        800: "",
        900: ""
      },
      error: {
        main: "#EB3F0C",
        50: "#FFF5F7",
        100: "#FEF1F3",
        200: "#FFE0E5",
        300: "#FFC7CD",
        400: "#FEA3A8",
        500: "#FD7A76",
        600: "#F95740",
        700: "#EB3F0C",
        800: "#A43C0C",
        900: "#582A0C"
      },
      info: {
        main: "#17A2B8",
        50: "#DBFAFF",
        100: "#C4F6FE",
        200: "#B6F1FF",
        300: "#9BE3FF",
        400: "#78CAFF",
        500: "#4A9EFF",
        600: "#1255FE",
        700: "#0313CC",
        800: "#18097A",
        900: "#120627"
      }
    }
  },
  font: {
    family: "InterVariable, sans-serif",
    size: {
      10: "0.6875rem",
      //11px
      20: "0.75rem",
      //12px
      30: "0.8125rem",
      //13px
      40: "1.125rem",
      //18px
      50: "1.25rem"
      //20px
    },
    weight: {
      regular: "400",
      medium: "500",
      semiBold: "600",
      bold: "700"
    },
    lineHeight: {
      10: "130%",
      20: "140%",
      30: "150%"
    }
  },
  // TODO: Change radius and spacing to use rems instead of px
  radius: {
    0: "0px",
    1: "2px",
    2: "4px",
    3: "6px",
    4: "8px",
    5: "10px",
    6: "12px",
    7: "16px",
    8: "20px",
    9: "24px",
    10: "32px",
    circular: "9999px"
  },
  spacing: {
    0: "0px",
    1: "2px",
    2: "4px",
    3: "8px",
    4: "12px",
    5: "16px",
    6: "20px",
    7: "24px",
    8: "32px",
    9: "40px",
    10: "48px"
  },
  shadows: {
    1: "0 1px 2px rgba(0,0,0,0.05)",
    2: "0 2px 4px rgba(0,0,0,0.1)",
    3: "0 4px 8px rgba(0,0,0,0.15)"
  },
  strokeWidth: {
    thin: "1px",
    regular: "2px",
    thick: "3px"
  },
  managementView: {
    colors: {
      neutral: {
        100: "#131313",
        90: "#131313E6",
        80: "#131313CC",
        64: "#131313A3",
        56: "#1313138F",
        24: "#1313133D",
        16: "#13131329",
        8: "#13131314",
        4: "#1313130A",
        0: "#FFFFFF"
      },
      success: {
        100: "#009912",
        4: "#0099120A"
      },
      error: {
        100: "#99000D",
        4: "#99000D0A"
      },
      appointmentState: {
        planned: "#BC7300",
        noReport: "#CF5E58",
        documented: "#00A181",
        didNotTakePlace: "#A16AC7"
      },
      inverse: {
        surface: "#2B2B2B",
        94: "#FFFFFFF0",
        90: "#FFFFFFE6",
        80: "#FFFFFFCC",
        8: "#FFFFFF14"
      }
    },
    font: {
      family: '"Alliance No.2", InterVariable, sans-serif',
      familySecondary: "InterVariable, sans-serif",
      size: {
        13: "0.8125rem",
        14: "0.875rem",
        15: "0.9375rem",
        16: "1rem",
        17: "1.0625rem",
        21: "1.3125rem"
      },
      weight: {
        400: "400",
        440: "440",
        500: "500",
        600: "600",
        700: "700"
      },
      lineHeight: {
        120: "1.2",
        164: "1.64"
      },
      letterSpacing: {
        tight: "-0.009375rem",
        // -0.15px = -0.009375rem (at 16px base)
        normal: "0rem"
      }
    },
    spacing: {
      2: "0.125rem",
      4: "0.25rem",
      6: "0.375rem",
      8: "0.5rem",
      10: "0.625rem",
      12: "0.75rem",
      14: "0.875rem",
      16: "1rem",
      18: "1.125rem",
      24: "1.5rem",
      26: "1.625rem",
      32: "2rem",
      48: "3rem",
      64: "4rem"
    },
    radius: {
      4: "0.25rem",
      10: "0.625rem",
      16: "1rem",
      20: "1.25rem",
      24: "1.5rem",
      32: "2rem"
    }
  },
  // Widget-specific tokens. font / spacing / radius mirror the managementView
  // shape (px-named keys, rem values) so they can diverge independently.
  fieldSalesTwo: {
    colors: {
      background: "#f0eeed",
      neutral: {
        50: "#fafaf9",
        200: "rgba(19,19,19,0.08)",
        300: "rgba(19,19,19,0.12)",
        400: "rgba(19,19,19,0.2)",
        500: "rgba(19,19,19,0.30)",
        600: "rgba(19,19,19,0.40)",
        700: "rgba(19,19,19,0.54)",
        800: "rgba(19,19,19,0.64)",
        850: "rgba(19,19,19,0.90)",
        900: "rgba(19,19,19,0.94)"
      },
      surface: {
        glassLight: "rgba(255,255,255,0.4)",
        glass: "rgba(255,255,255,0.56)",
        glassFlat: "#f8f8f7",
        glassLightFlat: "#fbfafa",
        glassMedium: "rgba(255,255,255,0.62)",
        glassStrong: "rgba(255,255,255,0.72)",
        glassBorder: "rgba(255,255,255,0.72)",
        glassBorderStrong: "rgba(255,255,255,0.8)",
        glassBorderBright: "rgba(255,255,255,0.9)",
        avatarRingBorder: "rgba(19,19,19,0.06)"
      },
      gradient: {
        // rgb(250,250,249) is neutral[50]; the ramp must stay the card's own colour, so re-derive
        // both if the palette moves.
        cardFooter: "linear-gradient(to top, rgba(250,250,249,1) 0%, rgba(250,250,249,1) 34%, rgba(250,250,249,0.9) 45%, rgba(250,250,249,0.72) 55%, rgba(250,250,249,0.5) 67%, rgba(250,250,249,0.3) 79%, rgba(250,250,249,0.13) 90%, rgba(250,250,249,0) 100%)"
      },
      accent: {
        action: "#fb3912",
        selection: "#3e71cc"
      },
      status: {
        error: {
          main: "#c80f44",
          tint: "rgba(200,15,68,0.08)"
        },
        success: {
          main: "#097561",
          tint: "rgba(9,117,97,0.08)"
        }
      },
      charts: {
        primary: "#fb3912",
        secondary: "#975543",
        linePrimary: "#3830ed",
        lineSecondary: "#706eba",
        muted: "#666666"
      }
    },
    font: {
      family: "InterVariable, sans-serif",
      familySecondary: '"Alliance No.2", InterVariable, sans-serif',
      size: {
        base: "0.9375rem",
        // 16px is the iOS Safari / WKWebView floor: focusing a form control below it zooms the page.
        input: "1rem",
        12: "0.75rem",
        13: "0.8125rem",
        14: "0.875rem",
        15: "0.9375rem",
        16: "1rem",
        17: "1.0625rem",
        18: "1.125rem",
        20: "1.25rem",
        21: "1.3125rem",
        22: "1.375rem",
        24: "1.5rem",
        30: "1.875rem",
        40: "2.5rem"
      },
      weight: {
        400: "400",
        440: "440",
        500: "500",
        520: "520",
        540: "540",
        550: "550",
        600: "600",
        700: "700"
      },
      lineHeight: {
        120: "1.2",
        125: "1.25",
        130: "1.3",
        136: "1.36",
        140: "1.4",
        148: "1.48",
        164: "1.64",
        168: "1.68"
      },
      letterSpacing: {
        hairline: "-0.0015rem",
        // -0.024px at 16px base
        subtle: "-0.00465rem",
        // -0.0744px at 16px base
        tight: "-0.009375rem",
        // -0.15px at 16px base
        tighter: "-0.0125rem",
        // -0.2px at 16px base
        normal: "0rem",
        wide: "0.0121875rem",
        // 0.195px at 16px base
        display: "-0.046875rem"
        // -0.75px at 16px base
      }
    },
    spacing: {
      2: "0.125rem",
      4: "0.25rem",
      6: "0.375rem",
      8: "0.5rem",
      10: "0.625rem",
      12: "0.75rem",
      14: "0.875rem",
      16: "1rem",
      18: "1.125rem",
      20: "1.25rem",
      24: "1.5rem",
      26: "1.625rem",
      32: "2rem",
      40: "2.5rem",
      44: "2.75rem",
      48: "3rem",
      50: "3.125rem",
      64: "4rem",
      72: "4.5rem",
      80: "5rem"
    },
    radius: {
      8: "0.5rem",
      10: "0.625rem",
      16: "1rem",
      18: "1.125rem",
      20: "1.25rem",
      24: "1.5rem",
      32: "2rem",
      38: "2.375rem",
      44: "2.75rem",
      circular: "9999px"
    },
    shadows: {
      glass: "0px 245px 34.5px rgba(0,0,0,0), 0px 157px 31.5px rgba(0,0,0,0), 0px 88px 26.5px rgba(0,0,0,0.01), 0px 39px 19.5px rgba(0,0,0,0.02), 0px 10px 11px rgba(0,0,0,0.02)"
    },
    effects: {
      blurSm: "6px"
    },
    motion: {
      duration: {
        fast: "120ms",
        base: "180ms",
        slow: "400ms",
        sheetIn: "220ms",
        sheetOut: "160ms"
      },
      easing: {
        emphasized: "cubic-bezier(0.22, 1, 0.36, 1)",
        scrollPin: "cubic-bezier(0.32, 0.72, 0, 1)",
        standard: "ease"
      }
    }
  }
};
export {
  r as baseTheme
};
//# sourceMappingURL=theme.js.map
